import React, { useState, useEffect } from "react";
import { colors } from "../../../../../themes/Colors";
import BaseButtons from "../../../base-buttons/BaseButtons";
import {
  AccidentReport,
  CurrentUserPopUp,
  DropDownBase,
  EnatisReport,
  KeyMovement,
  RequestValution,
  StolenVehicle,
  VehicleCertificates,
  VehicleForSale,
  VehicleImage,
  VehicleLiscense,
  VehicleOwnerPopUp,
} from "./components";
import TextInputField from "../../../text-input-field/TextInputField";
import AWS from "aws-sdk";
import VehicleCard from "../vehicle-card/VehicleCard";

const ManageVehicleView = ({
  display,
  onCloseClick,
  height,
  width,
  auth,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  setRefresh,
  refresh,
}) => {
  const [actionsOpen, setActionsOpen] = useState(false);
  const [actionSelected, setActionSelected] = useState("MANAGE");
  const [vehicleOwnerPopUp, setVehicleOwnerPopUp] = useState(false);
  const [currentUserPopUp, setCurrentUserPopUp] = useState(false);

  const [stolenVehiclePopUp, setStolenVehiclePopUp] = useState(false);

  const [keyTransferPop, setKeyTransferPop] = useState(false);

  const [vehicalOwnerData, setVehicleOwnerData] = useState(null);

  const [imagelink, setImageLink] = useState(null);

  const CheckActionOption = () => {
    if (actionSelected === "KEY MOVEMENT") {
      return () => setKeyTransferPop(true);
    } else {
      return () => setActionsOpen(true);
    }
  };

  const getUplaodImage = async () => {
    const S3_BUCKET = process.env.REACT_APP_BUCKET;
    const apiKey = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
    const secrectapiKey = process.env.REACT_APP_AWS_SECRET_KEY_ID;
    AWS.config.update({
      accessKeyId: apiKey,
      secretAccessKey: secrectapiKey,
    });
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: process.env.REACT_APP_REGION,
      signatureVersion: "v4",
    });

    const params = {
      Bucket: S3_BUCKET,
      Key: display ? display.vehicleImage : null,
    };

    var promise = s3.getSignedUrlPromise("getObject", params);
    // return promise;
    promise.then(
      function (url) {
        if (url) {
          setImageLink(url);
        }
        return url;
      },
      function (err) {
        console.log(err);
      }
    );
  };
  const getUserVehicleList = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userVehicles/getVehicleOwner",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: display ? display.vehicleOwnerUuid : null,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setVehicleOwnerData(respnseData.vehicleOwner);

        // setToastPop(true);
      }
    } catch (err) {}
  };
  useEffect(() => {
    if (display) {
      getUplaodImage();
      getUserVehicleList();
    }
  }, [display]);
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        height: display ? height : 0,
        width: "100%",
        backgroundColor: colors.white,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        zIndex: 100,
        transition: "all 0.3s",
        opacity: display ? 1 : 0,
      }}
    >
      <div
        style={{
          width: "100%",

          height: 60,
          position: "absolute",
          top: 30,

          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-evenly",
        }}
      >
        <div
          onClick={
            actionSelected === "MANAGE"
              ? onCloseClick
              : () => setActionSelected("MANAGE")
          }
          style={{
            height: "100%",
            flex: 0.25,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: 2,
            borderColor: colors.white,
            transition: "all 0.3s",
            WebkitBoxShadow: "-5px 5px 15px -1px #00000070",

            borderBottomRightRadius: 10,
            borderBottomLeftRadius: 10,
            backgroundColor: colors.orangeDark,
          }}
        >
          <div
            style={{
              marginTop: 10,
              fontWeight: "bold",
              color: colors.white,
              transition: "all 0.3s",
            }}
          >
            BACK
          </div>
        </div>

        <div
          style={{
            height: "100%",
            flex: 0.4,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            // borderBottomStyle: "solid",
            // borderWidth: buzzDisplay === "forYou" ? 3 : 0,
            // borderColor: colors.greenLight,
          }}
        >
          <div
            style={{
              width: "100%",
              textAlign: "center",
              marginTop: 20,
              fontWeight: "bold",
              fontSize: 16,
            }}
          ></div>
        </div>
        <div
          onClick={CheckActionOption()}
          style={{
            height: "100%",
            flex: 0.25,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: 2,
            borderColor: colors.white,
            transition: "all 0.3s",
            WebkitBoxShadow: "-5px 5px 15px -1px #00000070",

            borderBottomRightRadius: 10,
            borderBottomLeftRadius: 10,
            backgroundColor: colors.greenDark,
          }}
        >
          <div
            style={{
              marginTop: 10,
              fontWeight: "bold",
              color: colors.white,
              transition: "all 0.3s",
            }}
          >
            {actionSelected === "KEY MOVEMENT" ? "TRANSFER" : "ACTIONS"}
          </div>
        </div>
      </div>

      <div
        style={{
          position: "fixed",
          top: 45,
          width: "100%",
          zIndex: 12,
          height: actionsOpen ? "100%" : 0,
          overflow: "scroll",
        }}
      >
        <DropDownBase
          display={actionsOpen}
          width={"100%"}
          height={"100%"}
          borderRadius={8}
          backgroundColor={colors.secondaryGrey}
          data={[
            "KEY MOVEMENT",
            "STOLEN VEHCILE",
            "ACCIDENT REPORT",
            "REQUEST VALUATION",
            "VEHICLE FOR SALE",
            "VEHICLE LICENSING",
            "VEHICLE IMAGES",
            "VEHICLE CERTIFICATES",
            "ENATIS REPORT",
            "MANAGE",
          ]}
          optionHeight={50}
          setClose={setActionsOpen}
          setSelected={setActionSelected}
          backgroundColorButton={colors.greenLight}
        />
      </div>
      {/* <div
        style={{ position: "absolute", top: width > 899 ? 10 : 55, left: 10 }}
      >
        <BaseButtons
          label={"BACK"}
          borderRadius={8}
          onClick={
            actionSelected === "MANAGE"
              ? onCloseClick
              : () => setActionSelected("MANAGE")
          }
          width={65}
          height={40}
          backgroundColor={colors.orangeDark}
        />
      </div> */}

      <div style={{ padding: width > 899 ? 5 : 27 }} />
      <div
        style={{
          width: "100%",
          textAlign: "center",
          //   borderStyle: "solid",
          height: 40,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 14,
          fontWeight: "bold",
        }}
      >
        {actionSelected === "KEY MOVEMENT"
          ? "KEY HISTORY"
          : actionSelected.toLocaleUpperCase()}
      </div>
      {actionSelected === "MANAGE" ? (
        <div
          style={{
            width: "100%",
            marginTop: 10,
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflowY: "scroll",
            overflowX: "hidden",
          }}
        >
          <div
            style={{
              width: "100%",
              // paddingTop: 20,
              // paddingBottom: 20,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 120,
            }}
          >
            <VehicleCard
              width={width}
              // onManageClick={
              //   width > 899
              //     ? () => setManageVehicle(vehicle)
              //     : () => setVehicleManageView(vehicle)
              // }
              // type={type}
              licenceNr={display ? display.liscenseNumber : "loading"}
              // engineNr={vehicle.engineNumber}
              make={display ? display.make : "loading"}
              series={display ? display.series : "loading"}
              expireDate={"200 days"}
              // index={index + 1}
            />
          </div>
          <div
            style={{
              width: "100%",
              minHeight: 50,
              borderTopStyle: "solid",
              borderBottomStyle: "solid",
              marginTop: 20,
              borderColor: "#00000050",
              marginBottom: 10,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
              fontSize: 16,
              color: "#00000080",
            }}
          >
            IMPORTANT INFORMATION
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: "90%",
                backgroundColor: colors.white,
                borderRadius: 8,
                paddingTop: 20,
                paddingBottom: 20,
                WebkitBoxShadow: "0px 0px 7px 2px #00000080",
                marginTop: 20,
              }}
            >
              {/* <div
                style={{
                  minHeight: 200,
                  maxHeight: 200,
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    height: "90%",
                    width: "85%",
                    backgroundColor: "#00000015",
                    borderRadius: 8,
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img alt="photo" src={imagelink} style={{ width: "100%" }} />
                </div>
              </div> */}
              <TextInputField
                labelTitle={"REGISTER NR"}
                mini={true}
                readOnly={true}
                value={display ? display.registerNumber : "loading"}
                width={"100%"}
                size={"80%"}
              />
              {/* <TextInputField
                labelTitle={"LISCENSE NR"}
                mini={true}
                readOnly={true}
                value={display ? display.liscenseNumber : "loading"}
                width={"100%"}
                size={"80%"}
              /> */}
              <TextInputField
                labelTitle={"VIN NR"}
                mini={true}
                readOnly={true}
                value={display ? display.vinNumber : "loading"}
                width={"100%"}
                size={"80%"}
              />
              <TextInputField
                labelTitle={"ENGINE NR"}
                mini={true}
                readOnly={true}
                value={display ? display.engineNumber : "loading"}
                width={"100%"}
                size={"80%"}
              />
              <TextInputField
                labelTitle={"TARE KG"}
                mini={true}
                readOnly={true}
                value={"loading"}
                width={"100%"}
                size={"80%"}
              />
              <TextInputField
                labelTitle={"FIRST LISCENSING"}
                mini={true}
                readOnly={true}
                value={"loading"}
                width={"100%"}
                size={"80%"}
              />
              <TextInputField
                labelTitle={"DATE OF EXPIRY"}
                mini={true}
                readOnly={true}
                value={"loading"}
                width={"100%"}
                size={"80%"}
              />
              <TextInputField
                labelTitle={"AGE OF VEHICLE:"}
                mini={true}
                readOnly={true}
                value={"loading"}
                width={"100%"}
                size={"80%"}
              />
              <TextInputField
                labelTitle={"DAYS TO LICENCE EXPIRY"}
                mini={true}
                readOnly={true}
                value={"loading"}
                width={"100%"}
                size={"80%"}
              />
              <TextInputField
                labelTitle={"ESTIMATED RENEWAL COSTS"}
                mini={true}
                readOnly={true}
                value={"loading"}
                width={"100%"}
                size={"80%"}
              />
              {/* <TextInputField
                labelTitle={"MAKE"}
                mini={true}
                readOnly={true}
                value={display ? display.make : "loading"}
                width={"100%"}
                size={"80%"}
              />
              <TextInputField
                labelTitle={"SERIES"}
                mini={true}
                readOnly={true}
                value={display ? display.series : "loading"}
                width={"100%"}
                size={"80%"}
              /> */}
            </div>
          </div>

          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              marginTop: 25,
              marginBottom: 20,
            }}
          >
            <BaseButtons
              label={"VEHICLE OWNER"}
              width={"80%"}
              borderRadius={8}
              backgroundColor={colors.greenDark}
              onClick={() => setVehicleOwnerPopUp(true)}
            />
            <div style={{ height: 20 }} />
            <BaseButtons
              label={"CURRENT USER"}
              width={"80%"}
              borderRadius={8}
              backgroundColor={colors.greenDark}
              onClick={() => setCurrentUserPopUp(true)}
              disabled={true}
            />
            <div style={{ height: 20 }} />
            <BaseButtons
              label={"VEHICLE HSITORY"}
              width={"80%"}
              borderRadius={8}
              backgroundColor={colors.greenDark}
              disabled={true}
              // onClick={() => setCurrentUserPopUp(true)}
            />
          </div>
          <div style={{ padding: 60 }} />
        </div>
      ) : null}

      {actionSelected === "KEY MOVEMENT" ? (
        <KeyMovement
          keyTransferPop={keyTransferPop}
          setKeyTransferPop={setKeyTransferPop}
          data={display}
          auth={auth}
          setLoading={setLoading}
          setMessage={setMessage}
          setPopUpTitle={setPopUpTitle}
          setToastPop={setToastPop}
          setRefresh={setRefresh}
          refresh={refresh}
        />
      ) : null}
      {actionSelected === "STOLEN VEHCILE" ? (
        <StolenVehicle
          data={display}
          setLoading={setLoading}
          setMessage={setMessage}
          setPopUpTitle={setPopUpTitle}
          setToastPop={setToastPop}
          auth={auth}
        />
      ) : null}
      {actionSelected === "ACCIDENT REPORT" ? (
        <AccidentReport
          data={display}
          setLoading={setLoading}
          setMessage={setMessage}
          setPopUpTitle={setPopUpTitle}
          setToastPop={setToastPop}
        />
      ) : null}
      {actionSelected === "REQUEST VALUATION" ? (
        <RequestValution data={display} />
      ) : null}
      {actionSelected === "VEHICLE FOR SALE" ? (
        <VehicleForSale data={display} />
      ) : null}
      {actionSelected === "VEHICLE LICENSING" ? (
        <VehicleLiscense data={display} />
      ) : null}
      {actionSelected === "VEHICLE IMAGES" ? (
        <VehicleImage data={display} />
      ) : null}
      {actionSelected === "VEHICLE CERTIFICATES" ? (
        <VehicleCertificates data={display} />
      ) : null}
      {actionSelected === "ENATIS REPORT" ? (
        <EnatisReport data={display} />
      ) : null}
      <VehicleOwnerPopUp
        vehicalOwnerData={vehicalOwnerData}
        display={vehicleOwnerPopUp}
        onCloseClick={() => setVehicleOwnerPopUp(false)}
      />
      <CurrentUserPopUp
        display={currentUserPopUp}
        onCloseClick={() => setCurrentUserPopUp(false)}
      />
    </div>
  );
};

export default ManageVehicleView;
